<template>
  <PageWrapper :isLoading="isLoading" :isDense="isDense">
    <template #title> لیدربرد فرمن </template>
    <BRow>
      <BCol cols="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="questionsLimitToEnterLeaderboard"
          inputLabel="تعداد سوال مورد نیاز برای مشاهده کامل لیدربرد"
          inputPlaceholder="100 سوال"
          v-model="questionsLimitToEnterLeaderboard"
        >
          <template #append> سوال </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" class="d-flex align-items-center justify-content-end">
        <BButton
          variant="success"
          @click="renderEditLeaderboardLimitConfirmationModal"
        >
          ویرایش تعداد
        </BButton>
      </BCol>
      <EditLeaderboardQuestionLimitConfirmationDialog
        :newLimitCount="questionsLimitToEnterLeaderboard"
        :isOkButtonDisabled="isLoading"
        @updateLeaderboardQuestionLimit="updateQuestionLimitToEnterLeaderboard"
      ></EditLeaderboardQuestionLimitConfirmationDialog>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    isDense: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.getLeaderboardSetting();
  },
  data() {
    return {
      isLoading: false,
      questionsLimitToEnterLeaderboard: null,
    };
  },
  methods: {
    renderEditLeaderboardLimitConfirmationModal() {
      this.$bvModal.show("edit-leaderboard-question-limit-dialog");
    },
    closeEditLeaderboardLimitConfirmationModal() {
      this.$bvModal.hide("edit-leaderboard-question-limit-dialog");
    },
    async updateQuestionLimitToEnterLeaderboard() {
      try {
        this.isLoading = true;
        let _this = this;

        let setLeaderboardSetting = new SetLeaderboardSetting(_this);
        setLeaderboardSetting.setRequestParam({
          leaderBoardSetting: _this.questionsLimitToEnterLeaderboard,
        });
        await setLeaderboardSetting.fetch((response) => {
          if (response.isSuccess) {
            _this.getLeaderboardSetting();
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "ویرایش شد",
                icon: "MessageIcon",
                variant: "success",
                text: "تعداد سوال مورد نیاز برای مشاهده کامل لیدربرد با موفقیت ویرایش شد.",
              },
            });
            _this.closeEditLeaderboardLimitConfirmationModal();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text:
                  response.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید.",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getLeaderboardSetting() {
      try {
        this.isLoading = true;
        let _this = this;

        let getLeaderboardSetting = new GetLeaderboardSetting(_this);
        await getLeaderboardSetting.fetch((response) => {
          if (response.isSuccess) {
            this.questionsLimitToEnterLeaderboard = response.data;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomAppendText,
    EditLeaderboardQuestionLimitConfirmationDialog,
    BRow,
    BCol,
    BButton,
  },
};

import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import EditLeaderboardQuestionLimitConfirmationDialog from "@/views/components/SiteSettings/EditLeaderboardQuestionLimitConfirmationDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BRow, BCol, BButton } from "bootstrap-vue";
import {
  GetLeaderboardSetting,
  SetLeaderboardSetting,
} from "@/libs/Api/SiteSetting";
</script>
